import { Link } from 'react-router-dom';
import { MISTAKES, RELATED_TOOLS } from '@/mocks/lot';
import { SectionHeading } from './ui';

export function MistakesSection() {
  return (
    <section>
      <SectionHeading
        eyebrow="Lưu ý"
        title="Những sai lầm thường gặp khi tính khối lượng"
        subtitle="Tránh những lỗi phổ biến để quản trị rủi ro hiệu quả hơn."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {MISTAKES.map((m) => (
          <div key={m.title} className="rounded-2xl border border-slate-200/80 bg-white p-5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-violet-50 text-violet-600">
              <i className={`${m.icon} text-lg`} />
            </span>
            <p className="mt-4 text-sm font-semibold leading-snug text-slate-800">{m.title}</p>
            <p className="mt-2 text-xs leading-relaxed text-slate-400">{m.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function RelatedToolsSection() {
  return (
    <section>
      <SectionHeading
        eyebrow="Công cụ"
        title="Công cụ liên quan"
        subtitle="Khám phá thêm các công cụ tính toán hỗ trợ giao dịch của bạn."
      />

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {RELATED_TOOLS.map((t) => (
          <Link
            key={t.title}
            to={t.to}
            className="group rounded-2xl border border-slate-200/80 bg-white p-5 transition-all hover:-translate-y-0.5 hover:border-violet-200"
          >
            <span
              className="flex h-10 w-10 items-center justify-center rounded-xl text-white transition-transform group-hover:scale-105"
              style={{ backgroundColor: t.accent }}
            >
              <i className={`${t.icon} text-lg`} />
            </span>
            <p className="mt-4 text-sm font-semibold text-slate-800">{t.title}</p>
            <p className="mt-1.5 text-xs leading-relaxed text-slate-400">{t.desc}</p>
            <span className="mt-3 inline-flex items-center gap-1 text-xs font-semibold text-violet-600">
              Mở công cụ
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-0.5" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}